module.exports = __webpack_public_path__ + "img/compliance--icon.c4f2a8f0.svg";